export interface Config {
    API_URL: string;
    ASSETS_URL: string;
    SOCKET_URL: string;
}

export function getConfig(): Config {
    return {
        API_URL: process.env.REACT_APP_API_URL || "https://atlas1.dev/api/v1/portal",
        ASSETS_URL: process.env.REACT_APP_ASSETS_URL || "",
        SOCKET_URL: `wss://${process.env.REACT_APP_API_HOSTNAME}/api/v1/portal/websocket?jwt=`
    };
}
